// Sample publications. Replace items with real PDFs in /public/publications/*.pdf
// and real cover images once available. Tags are open-ended for filtering.

export const publicationTags = [
  "Impact", "Employment", "Entrepreneurship", "Methodology",
  "Research", "Hub", "Case Study", "Toolkit", "Sustainability", "Annual",
];

export const publicationTypes = [
  { key: "all", label: "All", color: "#111827" },
  { key: "iyaf", label: "IYAF publication", color: "#3663A8" },
  { key: "partner", label: "Partner publication", color: "#FF9F1C" },
];

/**
 * Each publication:
 *   id, title, source (IYAF or partner name), type (iyaf|partner),
 *   year, orientation ("portrait"|"landscape"), tags[], brief,
 *   coverImage (optional URL — falls back to brand cover), pdf (URL to PDF or '#'),
 *   accent (hex), published (set true when real PDF is uploaded)
 */

/** Placeholder examples — kept in repo for future uploads; hidden on the live site. */
export const publicationExamples = [
  {
    id: "annual-2024",
    published: false,
    title: "Annual Impact Report 2024",
    source: "IYAF",
    type: "iyaf",
    year: 2024,
    orientation: "portrait",
    tags: ["Annual", "Impact", "Employment", "Entrepreneurship"],
    brief: "A full review of the year: 4,500+ youth supported, $2M+ secured, 432 events, and the 97/3 model in action across five countries.",
    coverImage: null,
    pdf: "#",
    accent: "#3663A8",
    pages: 48,
  },
  {
    id: "97-3-whitepaper",
    published: false,
    title: "The 97/3 Model: A Methodology Whitepaper",
    source: "IYAF",
    type: "iyaf",
    year: 2024,
    orientation: "portrait",
    tags: ["Methodology", "Research", "Entrepreneurship"],
    brief: "Why 97% of founders need honest redirection and the 3% need intensive risk-mitigation. The framework, the data, and the field results.",
    coverImage: null,
    pdf: "#",
    accent: "#FF9F1C",
    pages: 32,
  },
  {
    id: "jordan-youth-employment",
    published: false,
    title: "Jordan Youth Employment Landscape 2024",
    source: "UNDP Jordan",
    type: "partner",
    year: 2024,
    orientation: "portrait",
    tags: ["Research", "Employment"],
    brief: "Co-authored sector analysis covering 12 industries, 8,000 employers and the gaps youth navigate to enter Jordan's labour market.",
    coverImage: null,
    pdf: "#",
    accent: "#567CB6",
    pages: 84,
  },
  {
    id: "hub-annual-brief",
    published: false,
    title: "IYAF Hub Annual Brief",
    source: "IYAF",
    type: "iyaf",
    year: 2024,
    orientation: "portrait",
    tags: ["Hub", "Annual"],
    brief: "How the 400 sqm Hub hosted 432 events, 75 initiatives, and 113 mentors, plus what the legal umbrella unlocked for new youth-led teams.",
    coverImage: null,
    pdf: "#",
    accent: "#3663A8",
    pages: 24,
  },
  {
    id: "sustainability-case-study",
    published: false,
    title: "Sustainability Cycle: A Case Study",
    source: "Friedrich Naumann Foundation",
    type: "partner",
    year: 2023,
    orientation: "portrait",
    tags: ["Sustainability", "Case Study"],
    brief: "An external study of the IYAF Consult engine, the 70% self-sustainability figure, and the 100% profit-reinvestment policy.",
    coverImage: null,
    pdf: "#",
    accent: "#8C8C8C",
    pages: 28,
  },
  {
    id: "se-toolkit",
    published: false,
    title: "Social Entrepreneurship Toolkit",
    source: "IYAF",
    type: "iyaf",
    year: 2023,
    orientation: "portrait",
    tags: ["Entrepreneurship", "Toolkit"],
    brief: "A practitioner's kit: validation canvas, redirection scripts, intensive-support playbooks, and the templates we use with cohorts.",
    coverImage: null,
    pdf: "#",
    accent: "#E01E84",
    pages: 56,
  },
];

/** Visible on the live site — only items with published: true. */
export const publications = publicationExamples.filter((p) => p.published === true);
